<div class="container-fuild" id="simplifySteps">
  <div class="row pt-1 d-flex align-items-center">
    <div class="col-md-8 step-title headPortion">
      <h5 class="mb-0">LCA and JOB Details</h5>
    </div>
    <div class="col-md-4 editBtn headerSubPortion"> 
      <ul>
        <li class="firstPortion"> 
          <lib-step-status-update-component-library [visaType]="inputData.caseType === 'I130' ? inputData.caseType : inputData.visatype" [stepDetails]="stepDetails" type="EDIT">
          </lib-step-status-update-component-library>
        </li>
        <li class="secondPortion">
          <lib-maximize-dialog-library [configData]="{'layoutCode':stepDetails?.stepActionList[0].layoutCode}"></lib-maximize-dialog-library>
          <i (click)="handleClose();" class="close-icon pi pi-times"></i>
        </li>
      </ul>  
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 p-0">
      <lib-assigning-task-library [visaType]="inputData.visatype" [stepDetails]="stepDetails"
        (updateStatus)="updateStepStatus($event)" [isViewMode]="inputData['isViewMode']"
        [isCaseRequest]="inputData['isCaseRequest']">
      </lib-assigning-task-library>
    </div>
  </div>
  <lib-last-update-library [inputDetails]="stepDetails" [primaryData]="inputData" sectionCode="LCA_JOB_DETAIL">
  </lib-last-update-library>
  <div class="row">
    <div class="col-12 infoPortion">
      <p class="m-0">How to ON/OFF Skip Step?</p><mat-icon  matTooltip="1. To skip any of the steps, use the slider.
      2. Turning ON the slider (to the right, shows in blue) skips the step.
      3. Turning OFF the slider (default left, shows in grey) retains the step in the petition.">info</mat-icon> 
    </div>
  </div>
  <div class="main-body footer-adjust">
    <p-accordion *ngFor="let item of skipList" [ngSwitch]="item?.layOutCode">
      <p-accordionTab (click)="onClickAccordion(0)" [selected]="activeTabIndex === 0" *ngSwitchCase="item?.layOutCode === 'H1B_LOTTERY_SELECTION' ? 'H1B_LOTTERY_SELECTION' : 'BEN_H1B_LOTTERY_SELECTION'" [hidden]="!isPetitionCap">
      <ng-template pTemplate="header">
        <div class="stepHeader">
          <div class="headPortion">
            <h6 [ngClass]="item && item.disabled == true ? 'disableAccordion' : ''">H-1B Lottery Selection Details</h6><mat-icon *ngIf="item && item.disabled && item.child && item.child.length > 0" [matTooltip]="item.infoMsg">info</mat-icon>
          </div>
          <div class="skipPortion" [ngClass]="disabledControls == true ? 'disableAccordion' : ''">Skip Step
            <p-inputSwitch [(ngModel)]="item && item.disabled" class="pl-2"  (onChange)="handleSwitchChange($event, item)">
            </p-inputSwitch>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <app-await-lottery-selection simplifiedH1b="true" [ngClass]="item.disabled == true ? 'disableAccordion' : ''" style="width:100%"></app-await-lottery-selection>
      </ng-template>
      </p-accordionTab> 
  
      <p-accordionTab (click)="onClickAccordion(1)" [selected]="activeTabIndex === 1" 
      *ngSwitchCase="item?.layOutCode === 'POSITION_DETAILS' ? 'POSITION_DETAILS' : 'BEN_POSITION_DETAILS'">
        <ng-template pTemplate="header">
          <div class="stepHeader"> 
            <div class="headPortion">
              <h6 [ngClass]="item && item.disabled == true ? 'disableAccordion' : ''">Position Details</h6><mat-icon *ngIf="item && item.disabled && item.child && item.child.length > 0" [matTooltip]="item.infoMsg">info</mat-icon>
            </div> 
            <div class="skipPortion" [ngClass]="disabledControls == true ? 'disableAccordion' : ''">Skip Step
              <p-inputSwitch [(ngModel)]="item && item.disabled" class="pl-2"  (onChange)="handleSwitchChange($event, item)">
              </p-inputSwitch>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <job-description-lca-position-library [primaryData]="inputData" [isForeignCompany]="false" [ngClass]="item.disabled == true ? 'disableAccordion' : ''" style="width:100%" (jobDescriptionSubmitted)="jobSubmitted($event)"></job-description-lca-position-library>
        </ng-template>
      </p-accordionTab> 
  
      <p-accordionTab (click)="onClickAccordion(2)" [selected]="activeTabIndex === 2" 
      *ngSwitchCase="item?.layOutCode === 'IDENTIFY_WORK_LOCATION' ? 'IDENTIFY_WORK_LOCATION' : 'BEN_IDENTIFY_WORK_LOCATION'">
        <ng-template pTemplate="header">
          <div class="stepHeader">
            <div class="headPortion">
              <h6 [ngClass]="item && item.disabled == true ? 'disableAccordion' : ''">Identify Work Location</h6><mat-icon *ngIf="item && item.disabled && item.child && item.child.length > 0" [matTooltip]="item.infoMsg">info</mat-icon>
            </div>
            <div class="skipPortion" [ngClass]="disabledControls == true ? 'disableAccordion' : ''">Skip Step
              <p-inputSwitch [(ngModel)]="item && item.disabled" class="pl-2"  (onChange)="handleSwitchChange($event, item)">
              </p-inputSwitch>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <job-description-lca-work-library [primaryData]="inputData"
              [isForeignCompany]="false" [ngClass]="item.disabled == true ? 'disableAccordion' : ''" style="width:100%"></job-description-lca-work-library>
        </ng-template>
      </p-accordionTab> 
  
      <p-accordionTab (click)="onClickAccordion(3)" [selected]="activeTabIndex === 3" *ngSwitchCase="item?.layOutCode === 'LIST_OF_DUTY' ? 'LIST_OF_DUTY' : 'BEN_LIST_OF_DUTY'">
        <ng-template pTemplate="header">
          <div class="stepHeader">
            <div class="headPortion">
              <h6 [ngClass]="item && item.disabled == true ? 'disableAccordion' : ''">List of duties</h6><mat-icon *ngIf="item && item.disabled && item.child && item.child.length > 0" [matTooltip]="item.infoMsg">info</mat-icon>
            </div>
            <div class="skipPortion" [ngClass]="disabledControls == true ? 'disableAccordion' : ''">Skip Step
              <p-inputSwitch [(ngModel)]="item && item.disabled" class="pl-2"  (onChange)="handleSwitchChange($event, item)">
              </p-inputSwitch>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <div class="row col-md-12 p-0">
            <list-job-duties [inputData]="inputData" [isSave]="true" [jobDescription]="jobPositionTitle" [ngClass]="item.disabled == true ? 'disableAccordion' : ''"></list-job-duties>
          </div>
        </ng-template>
        <ng-container *ngIf="activeTabIndex === 5">
          <lib-selecting-lca-soc-library [primaryData]="inputData"></lib-selecting-lca-soc-library>
        </ng-container>
      </p-accordionTab>
  
      <p-accordionTab (click)="onClickAccordion(4)" [selected]="activeTabIndex === 4" *ngSwitchCase="item?.layOutCode === 'SELECT_SOC_CODE_ASSIGN_LCA' ? 'SELECT_SOC_CODE_ASSIGN_LCA' : 'BEN_SELECT_SOC_CODE_ASSIGN_LCA'">
        <ng-template pTemplate="header">
          <div class="stepHeader">
            <div class="headPortion">
              <h6 [ngClass]="item && item.disabled == true ? 'disableAccordion' : ''">Select SOC Code & Assign LCA</h6><mat-icon *ngIf="item && item.disabled && item.child && item.child.length > 0" [matTooltip]="item.infoMsg">info</mat-icon>
            </div>
            <div class="skipPortion" [ngClass]="disabledControls == true ? 'disableAccordion' : ''">Skip Step
              <p-inputSwitch [(ngModel)]="item && item.disabled" class="pl-2"  (onChange)="handleSwitchChange($event, item)">
              </p-inputSwitch>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <lib-lca-soc-code-library [primaryData]="inputData" [simplifyH1b]="true" [ngClass]="item.disabled == true ? 'disableAccordion' : ''" style="width:100%"></lib-lca-soc-code-library>
        </ng-template>
      </p-accordionTab> 
  
      <p-accordionTab (click)="onClickAccordion(5)" [selected]="activeTabIndex === 5" *ngSwitchCase="item?.layOutCode === 'LINK_LCA_PETITION' ? 'LINK_LCA_PETITION' : 'BEN_LINK_LCA_PETITION'">
        <ng-template pTemplate="header">
          <div class="stepHeader">
            <div class="headPortion">
              <h6 [ngClass]="item && item.disabled == true ? 'disableAccordion' : ''">Link LCA to the Petition</h6><mat-icon *ngIf="item && item.disabled && item.child && item.child.length > 0" [matTooltip]="item.infoMsg">info</mat-icon>
            </div>
            <div class="skipPortion" [ngClass]="disabledControls == true ? 'disableAccordion' : ''">Skip Step
              <p-inputSwitch [(ngModel)]="item && item.disabled" class="pl-2"  (onChange)="handleSwitchChange($event, item)">
              </p-inputSwitch>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <lib-selecting-lca-soc-library [primaryData]="inputData" [ngClass]="item.disabled == true ? 'disableAccordion' : ''" style="width:100%"></lib-selecting-lca-soc-library>
        </ng-template>
      </p-accordionTab> 
    </p-accordion>
  </div>
  

  <div class="row">
    <div class="col-md-6 completeStep"></div>
    <div class="col-md-6 completeStep pt-3">
      <lib-step-status-update-component-library [isViewMode]="this.inputData['isViewMode']"
        [isCaseRequest]="this.inputData['isCaseRequest']"
        [visaType]="inputData.caseType != 'I130' ? inputData.visatype : inputData.caseType" [stepDetails]="stepDetails"
        [type]="typeOfButton" [showPreviousStepBtn]="showPrev" [showNextStepBtn]="showNext" class="d-flex col-12 justify-content-end"></lib-step-status-update-component-library>
    </div>
  </div>
</div>